import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  return (
    <div style={styles.root}>
      <div style={styles.page}>
        <button style={styles.back} onClick={() => navigate(-1)}>← Tilbake</button>

        <h1 style={styles.h1}>Personvernerklæring — Tippi</h1>
        <p style={styles.updated}>Sist oppdatert: {new Date().toLocaleDateString('nb-NO', { dateStyle: 'long' })}</p>

        <Section title="1. Behandlingsansvarlig">
          <p>Tippi AS (org.nr. under registrering), heretter «Tippi», er behandlingsansvarlig for personopplysninger som behandles i forbindelse med bruk av plattformen.</p>
          <p>Kontakt: <a href="mailto:personvern@tippi.no">personvern@tippi.no</a></p>
        </Section>

        <Section title="2. Hvilke opplysninger vi samler inn">
          <table style={styles.table}>
            <thead>
              <tr>
                <Th>Kategori</Th><Th>Opplysning</Th><Th>Grunnlag</Th>
              </tr>
            </thead>
            <tbody>
              <tr><Td>Sjåfør</Td><Td>Navn, e-post, telefon, org.nr.</Td><Td>Avtale</Td></tr>
              <tr><Td>Sjåfør</Td><Td>GPS-posisjon ved søk etter oppdrag, og under et oppdrag fra tildeling til levering</Td><Td>Samtykke</Td></tr>
              <tr><Td>Bestiller</Td><Td>Navn, e-post, telefon, org.nr.</Td><Td>Avtale</Td></tr>
              <tr><Td>Begge</Td><Td>Oppdragshistorikk og leveringsdokumenter</Td><Td>Legitim interesse / lovkrav</Td></tr>
              <tr><Td>Begge</Td><Td>Innlogging (tidspunkt, rolle, enhetstype), viktige hendelser i appen og tekniske feil</Td><Td>Legitim interesse (drift, sikkerhet, feilsøking)</Td></tr>
              <tr><Td>Begge</Td><Td>Henvendelser til support (tilbakemelding i appen, e-post, telefon) og vår oppfølging</Td><Td>Avtale / legitim interesse</Td></tr>
            </tbody>
          </table>
        </Section>

        <Section title="3. Bruk av opplysningene">
          <p>Opplysningene brukes til å:</p>
          <ul style={styles.list}>
            <li>Formidle kontakt mellom sjåfører og bestillere</li>
            <li>Generere leveringsbekreftelser og fakturaer</li>
            <li>Oppfylle krav i Vegfraktloven (fraktbrev)</li>
            <li>Forebygge svindel og misbruk av plattformen</li>
          </ul>
        </Section>

        <Section title="4. Deling med tredjeparter">
          <p>Vi deler opplysninger med følgende databehandlere:</p>
          <ul style={styles.list}>
            <li><strong>Google Firebase</strong> — skyinfrastruktur, autentisering og lagring</li>
            <li><strong>Stripe</strong> — betalingsbehandling (PSD2-lisensiert)</li>
            <li><strong>Google Maps</strong> — kartvisning og adressevalidering</li>
            <li><strong>One.com</strong> — e-posttjeneste for support@tippi.no og fakturaer</li>
            <li><strong>Anthropic</strong> — AI-assistenten Claude, brukt av Tippi til å lese saker og tilhørende teknisk logg for feilsøking og til å lage utkast til svar</li>
          </ul>
          <p>Tippi bruker AI-assistenten som hjelpemiddel. En ansatt godkjenner alltid svar før de sendes, og AI-assistenten tar ingen avgjørelser om deg på egen hånd. Vi sender bare med opplysningene som trengs for å behandle saken.</p>
          <p>Alle databehandlere er bundet av databehandleravtaler og GDPR.</p>
        </Section>

        <Section title="5. Lagringstid">
          <ul style={styles.list}>
            <li>Personopplysninger slettes innen 30 dager etter avsluttet konto</li>
            <li>Oppdragsdata og fakturaer beholdes i 5 år (regnskapsloven)</li>
            <li>Aktivitetslogg (innlogging, hendelser og feil) slettes automatisk etter 90 dager</li>
            <li>Supportsaker slettes 24 måneder etter at de er løst</li>
          </ul>
        </Section>

        <Section title="6. Dine rettigheter">
          <p>Du har rett til innsyn, retting, sletting og dataportabilitet. Send forespørsel til <a href="mailto:personvern@tippi.no">personvern@tippi.no</a>.</p>
          <p>Du kan klage til <a href="https://www.datatilsynet.no" target="_blank" rel="noreferrer">Datatilsynet</a>.</p>
        </Section>

        <Section title="7. Lokasjonsdeling">
          <p>Sjåfører samtykker eksplisitt til GPS-lokalisering før posisjonen brukes. Posisjonen brukes til å vise og sortere oppdrag etter nærhet.</p>
          <p>Når sjåføren har et oppdrag, ser bestilleren av det oppdraget sjåførens posisjon fra oppdraget er tildelt til det er levert. Posisjonen oppdateres bare mens sjåføren har appen åpen, deles ikke med andre, og slettes fra oppdraget når det er levert eller kansellert.</p>
          <p>Samtykket kan trekkes tilbake under Innstillinger i appen. Da deles ikke posisjonen med bestiller, og oppdrag kan ikke sorteres etter nærhet.</p>
        </Section>

        <Section title="8. Aktivitetslogg og feilsøking">
          <p>For å drifte og feilsøke plattformen logger vi når du logger inn og ut (med rolle og enhetstype, for eksempel «Android · Chrome»), viktige hendelser som oppdrag, bud, fakturaer og profilendringer, og tekniske feil. Vi logger aldri passord, betalingskortdata eller kontonummer. Loggen er bare tilgjengelig for Tippis administratorer og slettes etter 90 dager.</p>
        </Section>

        <Section title="9. Support og henvendelser">
          <p>Du kan kontakte oss via tilbakemeldingsfunksjonen i appen, på e-post til support@tippi.no eller på telefon. Vi lagrer henvendelsen, svarene våre og interne notater. Sender du tilbakemelding fra appen, følger side, enhetstype og din siste aktivitet med for å gjøre feilsøkingen enklere. Henvendelser fra telefon og e-post er bare synlige for Tippis ansatte; saker fra appen kan du selv se under Gi tilbakemelding.</p>
        </Section>

        <p style={{ fontSize: 12, color: '#aaa', marginTop: 40 }}>
          ⚠️ Dette er en midlertidig personvernerklæring. Juridisk gjennomgang anbefales før pilotlansering.
        </p>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 28 }}>
      <h2 style={{ fontSize: 16, fontWeight: 700, color: '#1a1a2e', margin: '0 0 10px' }}>{title}</h2>
      {children}
    </div>
  );
}

function Th({ children }) {
  return <th style={{ textAlign: 'left', padding: '8px 12px', fontSize: 12, fontWeight: 700, color: '#999', textTransform: 'uppercase', borderBottom: '2px solid #eee' }}>{children}</th>;
}
function Td({ children }) {
  return <td style={{ padding: '8px 12px', fontSize: 14, borderBottom: '1px solid #f5f5f5' }}>{children}</td>;
}

const styles = {
  root:    { minHeight: '100vh', background: '#f4f6fa', padding: '32px 20px' },
  page:    { maxWidth: 680, margin: '0 auto', background: '#fff', borderRadius: 12, padding: '36px 40px', boxShadow: '0 1px 10px rgba(0,0,0,0.07)' },
  back:    { background: 'none', border: 'none', color: '#555', fontSize: 14, cursor: 'pointer', padding: '0 0 16px', display: 'block' },
  h1:      { fontSize: 24, fontWeight: 700, color: '#1a1a2e', margin: '0 0 4px' },
  updated: { fontSize: 13, color: '#999', margin: '0 0 28px' },
  table:   { width: '100%', borderCollapse: 'collapse', fontSize: 14, marginBottom: 8 },
  list:    { paddingLeft: 20, lineHeight: 2, fontSize: 14, color: '#444' },
};
